

























import { Vue, Component, Prop } from 'vue-property-decorator';
import axios from 'axios';
import Container from '../../Registration/v2/Container.vue';
import RegistrationCard from '../../Registration/v2/Card.vue';
import CardHeader from '../../Registration/v2/Header.vue';
import OTPLoginForm from './OTPLoginForm.vue';
import { AuthParams } from '@/models/userdata/authparams';
import { vxm } from '@/store.vuex';
import router from '../../../router';
import { mutation } from 'vuex-class-component';

@Component({
  components: {
    Container,
    RegistrationCard,
    CardHeader,
    OTPLoginForm,
  },
})
export default class OTPLogin extends Vue {
  @Prop() sessionExpired;
  //@Prop({ default: ''}) username: string = '';
  private username: string = '';
  private isEmailPresent: boolean = false;

  private authParams: AuthParams = new AuthParams();
  private password: any = [];
  private errors: string = '';
  private isMobileScreen: boolean = false;
  private canResendCode: boolean = true;
  private validationType: string = 'email.';
  private showCounter: boolean = true;
  private confirmButtonName: string = 'Continue';
  private onBackName: string = 'Back to log in';
  $wlToastr: any;
  goBack() {
    this.$router.push({ name: 'Login' });
  }

  getOAuthProvider(): string {
    return this.$cookies.get('OAuthProvider');
  }

  get getUsername(): string {
    return this.username;
  }

  @mutation
  setPassword(object) {
    this.password.splice(object.index, 1, object.value);
  }

  async onLogin() {
    this.errors = '';
    this.authParams.companyCode = this.$store.state.jobs.companyCode;
    let password = this.password.join('');
    if (!password || password.length === 0) {
      this.errors = 'otp-login.entercode';
    } else if (password.length < 5) {
      this.errors = 'otp-login.invalidcode';
    } else {
      this.authParams.username = this.username;
      this.authParams.password = password;

      const resp = await vxm.users.otpLogin(this.authParams).then((value) => {
        if (value === false) {
          /*const errorMessageText =
            vxm.users.getErrorMesaageLogin !== ''
              ? vxm.users.getErrorMesaageLogin
              : 'login.failure.incorrect.password';*/
          this.errors = 'otp-login.invalidcode';
          if(vxm.users.getErrorMesaageLogin.startsWith("User not found:")){
            this.errors = vxm.users.getErrorMesaageLogin;
          }
        } else {
          const url = this.$cookies.get('NavigateTo_ID');
          if (url && !vxm.users.ForceChangePwd) {
            // when the user want to apply to a job
            console.log('NavigateTo_ID', url);
            const [, id] = url.split(':');
            this.$router.push({
              name: 'Jobdetails',
              params: { JobID: id },
            });
          } else {
            console.log(
              'getRouterAfterOTPForm',
              vxm.users.getRouterAfterOTPForm,
            );
            vxm.users.Rudderstack.trackEvent("OTP Entered", { LocationWhereOtpEntered: "Signup" })
            if (vxm.users.getRouterAfterOTPForm === "myjobstatus") {
              router.push({ path: "/myjobstatus" })
            } else {
              router.push({ name: vxm.users.getRouterAfterOTPForm });
            }
          }
          if (
            vxm.configs.getGlobalConfigValue('IS_GDPR_ENABLED') &&
            vxm.utility.IsNewlyRegisteredUser &&
            !vxm.configs.getGlobalConfigValue('STAGES_TO_SKIP_OTP_VERIFICATION')
          ) {
            vxm.users.saveTermsOfServiceAndMarketingEmailFlag(true, true);
          }
        }
      });
    }
  }
  async resendOtp() {
    this.showCountTime();
    this.errors = '';
    let request = {
      companyCode: vxm.jobs.BrandingInfo.companycode,
      userEmail: this.username,
    };

    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const response = await axios.post(
      '/wl-profile-svc/api/user-profile/v2/forgotPassword',
      request,
      {
        headers: {
          Authorization: bearerToken,
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      },
    );

    if (response.data.success === true) {
      vxm.users.setRouterAfterOTPForm(vxm.users.getRouterAfterOTPForm);

      this.$wlToastr(
        'success',
        this.$t('otp-login.toast.codesentmessage'),
        this.$t('otp-login.toast.title'),
      );
    } else {
      const errorMessage = response.data.error;
      this.$wlToastr('error', errorMessage, this.$t('otp-login.toast.title'));
    }
  }

  get resendCodeSecondsToCount(): number {
    return vxm.utility.timeToResendOTPCode;
  }

  onFinishCountdown() {
    this.canResendCode = false;
    this.showCounter = false;
  }

  showCountTime() {
    this.canResendCode = true;
    this.showCounter = true;
  }

  mounted() {
    this.isMobileScreen = vxm.utility.isMobileDevice;
    if (this.sessionExpired) {
      this.$wlToastr(
        'info',
        'Your session has timed out. Please sign in again.',
        'Session Timeout',
      );
    }
    this.username = vxm.users.UserParams.email || this.$route.params.username;
    this.isEmailPresent = null != this.username && '' !== this.username;
    // const url = new URL(window.location.href);
    // const deviceToken = url.searchParams.get('token');
    // if(deviceToken){
    //   vxm.utility.setUserDeviceToken(deviceToken);

    // }
  }
}
